// import jQuery from 'CommonScripts/jquery-1.10.2'; 

var jsonVeluxActiveAppDemo;
(function(window, document, $) {

    var getActiveAppDemoData = function() {
        var parameter = { containerId: $('#hfContainerId').val(), language: $('#hfLanguage').val() };

        $.ajax({
            type: "POST",
            cache: false,
            url: "/services/marketing/VeluxActiveAppDemoService.asmx/GetVeluxAppDemoContent",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(parameter),
            success: function(result) {
                jsonVeluxActiveAppDemo = result.d;
                //console.log(jsonVeluxActiveAppDemo);
            },
            error: function(request, status, error) {
                console.log(error);
            }
        });
    }

    $(document).ready(function() {
        var veluxActiveAppDemoClass = $(".veluxActiveAppDemoClass");
        if (veluxActiveAppDemoClass.length > 0) {
            getActiveAppDemoData();
        }
    });
})(window, document, jQuery);
